export default {
  process: {
    searchPlaceholder: '输入过程编号进行搜索',
    processNo: '过程编号',
    processName: '过程名称',
    entryNo: '准入项编号',
    entryName: '准入项名称',
    judgmentCriteria: '判断标准',
    fraction: '满分',
    passMark: '合格标志',
    entry: '准入项',
    addEntry: '添加项'
  },
  item: {
    entryNo: '准入项编号',
    entryName: '准入项名称',
    judgmentCriteria: '判断标准',
    fraction: '满分',
    passMark: '合格标志',
    judgmentCriteriaOptions: ['根据分数', '根据条件'],
    accessId: '附件'
  },
  srmsupplierassessment: {
    searchPlaceholder: '供应商名称',
    classifyNo: '供应商分类',
    sponsorDepartment: '发起部门',
    processNo: '准入过程',
    status: '状态',
    statusOptions: ['已发布', '待评估', '考评完成'],
    whetherAccess: '是否准入',
    whetherAccessOptions: ['不予准入', '准入'],
    classifyName: '供应商分类名称',
    supplierName: '供应商名称',
    principal: '负责人',
    mobile: '联系方式',
    assessmentDate: '考核日期',
    numEvaluations: '评估次数',
    processName: '准入过程',
    exportName: '准入评估跟踪表',
    chooseOneLine: '请选择一行数据！',
    textareaPlaceholder: '输入任务描述…',
    standardTitle: '判断条件',
    standardOptions: ['按分数', '按条件'],
    standardTitleOptions: ['满分', '合格'],
    formTitle: '发放设置',
    all: '全部',
    assessment: '评估',
    admittance: '准入',
    unadmittance: '不予准入',
    pushSupplierInfoToErp: '抛转erp',
    evaluateTitle: '填写评价',
    evaluateHeader: ['您正在进行', '操作，请填写评价（多条评价请以 ；隔开）'],
    evaluatePlaceholder: '此处填写内容将会在“合格供应商证书”中适用的服务和场景里体现，请谨慎填写!',
    pushSupplierInfoToErpTitle: '供应商补充信息',
    usualCurrencyNo: '惯用币种',
    usualTaxTypeNo: '惯用税种',
    payTermsNo: '付款条件',
    txTermsNo: '价格条件'
  }
}
